import React from "react";
import { byCodes } from "../../../constant/General";
import ContentWrapper from "../../live2/tc/ContentWrapper";
import DrawingTable from "../../live2/kp/day/DrawingTable";
import ResultTable from "./day/ResultTable";


const ResultTCDay = (props) => {
    const { result, config, image } = props;
    let posts = byCodes(result.rightResults, ["F", "A", "B", "C", "D"]);

    return <ContentWrapper isDef image={image} type={config.type} shift="day">
        <DrawingTable className="ps-3" {...props} />
        <ResultTable posts={posts} />
    </ContentWrapper>
}

export default ResultTCDay;